
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion'
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '@/components/ui/card'
import { AlertCircle, ArrowLeft, CreditCard } from 'lucide-react'
import { Button } from '@/components/ui/button'

const PaymentCancelled: React.FC = () => {
    const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="bg-white rounded-xl p-8 flex flex-col items-center justify-center max-w-lg w-full">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Card className="max-w-md w-full mx-auto shadow-none border-0 hover:bg-unset dark:bg-gray-900 ">
              <CardHeader className="text-center space-y-2">
                <div className="flex justify-center">
                  <div className="rounded-full bg-yellow-100 p-3">
                    <AlertCircle className="h-12 w-12 text-yellow-600" />
                  </div>
                </div>
                <CardTitle className="text-xl font-semibold tracking-tight">
                  Payment Not Completed
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center space-y-4">
                <p className="text-sm text-muted-foreground">
                  Your payment process was not completed. This could be due to cancellation or an interruption in the payment session.
                </p>
                <div className="text-left bg-secondary/50 rounded-lg p-4 text-sm">
                  <h3 className="font-semibold mb-4 text-lg">What happens next?</h3>
                  <ul className="list-disc list-inside text-left space-y-1">
                    <li>Your account status remains unchanged</li>
                    <li>No charges have been made to your payment method</li>
                    <li>You can try the payment process again at any time</li>
                  </ul>
                </div>
              </CardContent>
              <CardFooter className="flex flex-col gap-4 p-0 mt-5">
                <Button className="w-full bg-primary-500 hover:bg-primary-600" onClick={() => navigate('/subscription')}>
                    <CreditCard className="mr-2 h-4 w-4" />
                    Try Payment Again
                </Button>
                <Button variant="outline" className='bg-white hover:bg-gray-100 w-full' onClick={() => navigate('/')}>
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Go to Dashboard
                </Button>
              </CardFooter>
            </Card>
          </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancelled;